import { render } from "./ExamOfficialBadge.vue?vue&type=template&id=06610b36&scoped=true"
import script from "./ExamOfficialBadge.vue?vue&type=script&lang=js"
export * from "./ExamOfficialBadge.vue?vue&type=script&lang=js"

import "./ExamOfficialBadge.vue?vue&type=style&index=0&id=06610b36&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06610b36"]])

export default __exports__